import { useAuth } from "@/hooks/use-auth";
import { UserAvatar, UserInfoDropdown } from "../user";

import { Button } from "@/styles/ui/button";
import { useNavigate } from "react-router-dom";

const HeaderUserInfo = () => {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <UserInfoDropdown side="bottom">
      <UserAvatar user={user} />
    </UserInfoDropdown>
  );
};

export const DSDHeader = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-white border-b border-neutral-200 flex items-center justify-between px-6 py-4 h-14 gap-[1.719px]">
      <Button
        className="h-6 relative w-[142px]"
        variant="ghost"
        onClick={() => navigate("/")}
        type="button"
      >
        <div className="absolute h-[13.581px] left-0 top-[3.276px] w-[72.354px]">
          <img
            alt=""
            className="block max-w-none size-full"
            src="/login-assets/invector-logo.svg"
          />
        </div>
        <div className="absolute font-['Castoro'] italic leading-[0] left-[107.573px] text-[16.552px] text-blue-500 text-center text-nowrap top-0 tracking-[-0.0033px] translate-x-[-50%]">
          <p className="adjustLetterSpacing block leading-[1.445] whitespace-pre">
            for XBRL
          </p>
        </div>
      </Button>

      <HeaderUserInfo />
    </div>
  );
};
